import { MessageDescriptor } from '@lingui/core'
import { defineMessage } from '@lingui/macro'

export const SegmentCodes = {
    SUBTOTAL: 'subtotal',
    SHIPPING: 'shipping',
    TAX: 'tax',
    GRAND_TOTAL: 'grand_total',
    DISCOUNT: 'discount',
    FREE_GIFTS: 'free_gifts',
}

export const segmentCodeTitles: { [key: string]: MessageDescriptor } = {
    [SegmentCodes.SHIPPING]: defineMessage({
        id: 'cart.cartTotals.shipping',
        message: `Delivery`,
    }),
    [SegmentCodes.TAX]: defineMessage({
        id: 'cart.cartTotals.tax',
        message: `Tax`,
    }),
    [SegmentCodes.GRAND_TOTAL]: defineMessage({
        id: 'cart.cartTotals.grandTotal',
        message: `Total (incl VAT)`,
    }),
    [SegmentCodes.SUBTOTAL]: defineMessage({
        id: 'cart.cartTotals.subTotal.label',
        message: `Subtotal`,
    }),
}
